const JS_HOOK_SET_COOKIE_BUTTON = '[js-hook-set-cookie-on-click]';
const JS_HOOK_TRIGGER_CONTENT = '[js-hook-professional-trigger-content]';
const JS_HOOK_TRIGGER_RESULT = '[js-hook-professional-trigger-result]';

const HIDDEN_CLASS = 'u-hidden';

class professionalTrigger {
  constructor(element) {
    this.element = element;
    this.button = this.element.querySelector(JS_HOOK_SET_COOKIE_BUTTON);
    this.content = this.element.querySelector(JS_HOOK_TRIGGER_CONTENT);
    this.result = this.element.querySelector(JS_HOOK_TRIGGER_RESULT);

    this.bindEvents();
  }

  bindEvents() {
    if (this.button) {
      this.button.addEventListener('click', (e) => this.clickHandler(e));
    }
  }

  clickHandler(e) {
    e.preventDefault();

    this.content.classList.add(HIDDEN_CLASS);
    this.result.classList.remove(HIDDEN_CLASS);
  }
}

export default professionalTrigger;
